
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class IconFont extends Vue {
  @Prop({ default: 'icon-xx' }) type!: string;
}
